__webpack_require__.p = "/vote-viewer-mg/";